import * as React from "react";

const SvgCommonIconReduce = props => <svg viewBox="0 0 16 16" xmlSpace="preserve" width="1em" height="1em" {...props}><path d="M12 8.8H4c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h8c.4 0 .8.3.8.8s-.4.8-.8.8z" /></svg>;

export default SvgCommonIconReduce;